import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { EMPTY, catchError, mergeMap, of, throwError } from 'rxjs';
import { SettingsService } from '../setting-service/setting.service';

export const sessionInterceptor: HttpInterceptorFn = (request, next) => {
    const token = request.headers.get('auth-token');
    if (!token) return next(request);

    const session = inject(SettingsService);
    const router = inject(Router);

    const expireSession = () => {
        // Uma resposta atrasada não deve encerrar uma sessão iniciada depois.
        if (session.user?.token === token) {
            session.logado = false;
            session.user = {};
            localStorage.removeItem('USER_DATA');
            void router.navigate(['/'], { replaceUrl: true });
        }
        return EMPTY;
    };

    return next(request).pipe(
        mergeMap(event => event instanceof HttpResponse && (event.body as { status?: number } | null)?.status === 401
            ? expireSession() : of(event)),
        catchError(error => error instanceof HttpErrorResponse && error.status === 401
            ? expireSession() : throwError(() => error))
    );
};
